export const getToken = () => localStorage.getItem("flexgrade__token")

export const addToken = (token) => localStorage.setItem("flexgrade__token", token);

export const removeToken = () => localStorage.removeItem("flexgrade__token")

export const getAssessmentData = () => {
    const data = localStorage.getItem("flexgrade__assesment__data");
    if (data) {
       return JSON.parse(data)
    } else {
        return null
    }
}

export const addAssessmentData = (data) => localStorage.setItem("flexgrade__assesment__data", JSON.stringify(data));

export const removeAssessmentData = () => localStorage.removeItem("flexgrade__assesment__data")